import { expensesApi } from '../api/expensesApi'
import type { ExpenseCategoryCreateData } from '../schema/expensesSchema'

export const createCategory = async (category: ExpenseCategoryCreateData) => {
  try {
    const { data } = await expensesApi.createCategory(category)
    return data
  } catch (error) {
    console.error(`Error creating category: `, error)
    throw error
  }
}
